import styled from '@emotion/styled'

import { fonts, colors, metrics } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'
import { SectionHeader } from 'component-library/section-header/SectionHeader/SectionHeader'

import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export interface StyledTopicListContainerProps {
    verticalSpacing?: keyof ThemeMargins
}

export const StyledTopicListContainer = styled('div')<StyledTopicListContainerProps>(
    ({ theme, verticalSpacing }) => ({
        ...conditionalStyles(theme.kind === 'thewest', {
            padding: calcRem(metrics.thewest.margins.md, 0, metrics.thewest.margins.md - 10),
            borderTop: `1px solid ${colors.thewest.greyDolphin}`,
            borderBottom: `1px solid ${colors.thewest.greyDolphin}`,
        }),
        ...conditionalStyles(theme.kind === 'perthnow', {
            alignItems: 'center',
            display: 'flex',
        }),
        marginBottom: verticalSpacing && theme.margins[verticalSpacing],
    })
)

export const StyledTopicNav = styled('nav')({
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
})

export const StyledHeader = styled('h2')({
    alignSelf: 'flex-start',
    color: colors.black,
    fontFamily: fonts.perthnow.sansSerifCond,
    fontSize: calcRem(16),
    fontWeight: 700,
    lineHeight: 1,
    margin: `0 ${calcRem(15)} 0 0`,
    textTransform: 'uppercase',
})

export const StyledSectionHeader = styled(SectionHeader)({
    marginBottom: calcRem(metrics.thewest.margins.md),
})
